//=================Home Data================

export const mystorydata_Request = 'mystorydata_Request';
export const mystorydata_SUCCESS = 'mystorydata_SUCCESS';
export const mystorydata_FAILURE = 'mystorydata_FAILURE';

//=================Home Data================
